import { MetaPartnerApiClient } from '@fourthwall/services/dist/MetaPartnerApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useMetaStatusMutation = createMutationHook(MetaPartnerApiClient.updateMetaStatus, {
  mutationKey: ['metaStatusMutation'],
})
